import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Button, Modal, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { faCircleCheck, faXmark, faLock } from '@fortawesome/free-solid-svg-icons';

import CartCalcReselect from 'Reselects/cartcalc';
import {
  BUNDLE_EXIT_OFFER_MODAL,
  toggleBundleExitOfferModal,
} from 'Redux/ducks/modal';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import CheckoutModalSummary from 'Components/Checkout/CheckoutModalSummary';
import BundleExitOfferModalItem from 'Components/Bundle/BundleExitOfferModalItem';
import { currencyCode } from 'Helpers/Geo/data';

import 'Components/Bundle/BundleExitOfferModal.scss';

const BundleExitOfferModal = () => {
  const dispatch = useDispatch();
  const cartCalc = useSelector(state => CartCalcReselect(state));
  const open = useSelector(state => state.modal[BUNDLE_EXIT_OFFER_MODAL]);
  const handleModalToggle = () => dispatch(toggleBundleExitOfferModal());
  const { pathname } = useSelector(state => state.router.location);
  const pickAndMixes = useSelector(state => state.pickAndMix);

  const pickAndMixMatch = pathname.match(/^\/pick-and-mix\/([^/]+)/);
  const pickAndMixName = pickAndMixMatch?.[1] || null;

  const currentPickAndMix = pickAndMixName &&
    pickAndMixes?.all?.find(bundle => bundle.slug === pickAndMixName);

  const pickAndMixProductIds = currentPickAndMix?.products?.map(p => p._id) || [];

  const pickAndMixCartItems = cartCalc.items.filter(item =>
    pickAndMixProductIds.includes(item._id),
  );

  const itemCount = pickAndMixCartItems.length;

  const sortedTiers = currentPickAndMix?.tiers?.sort((a, b) => a.quantity - b.quantity) || [];
  const minTier = sortedTiers[0] || null;

  const currentTier = itemCount >= (minTier?.quantity || 0)
    ? sortedTiers
      .filter(tier => tier.quantity <= itemCount)
      .sort((a, b) => b.quantity - a.quantity)[0]
    : null;

  const currentPrice = currentTier?.price[currencyCode];
  const currentFullPrice = pickAndMixCartItems?.reduce((acc, item) =>
    acc + item.out.price, 0);
  const currentDiscount = currentFullPrice - currentPrice;

  return (
    <Modal
      isOpen={open}
      toggle={handleModalToggle}
      className="bundle-exit-offer-modal"
    >
      <ModalBody>
        <div className="bundle-exit-offer-modal-head">
          <div className="bundle-exit-offer-modal-title">
            <FontAwesomeIcon icon={faCircleCheck} className="fa-circle-bkg" />
            <h4>
              <FormattedMessage
                id="bundle-exit-offer-modal.header"
                defaultMessage="Don't miss out on these bundle savings!"
              />
            </h4>
          </div>
          <Button
            color="link"
            className="close-button-bundle-exit-offer"
            onClick={handleModalToggle}
          >
            <FontAwesomeIcon icon={faXmark} title="Close modal" className="remove-button-svg" />
          </Button>
        </div>

        <div className="bundle-exit-offer-modal-body">
          <div className="bundle-exit-offer-modal-items">
            <React.Fragment>
              {pickAndMixCartItems.map(item => <BundleExitOfferModalItem item={item} />)}
            </React.Fragment>

            <div className="d-block d-sm-none">
              <div className="checkout-modal-summary">
                <div className="summary-line" />
                <Row className="mobile-total mb-2">
                  <Col>
                    <FormattedMessage id="bundle-exit-offer-modal.total" defaultMessage="TOTAL" />
                  </Col>
                  <Col className="text-right">
                    <SpecialFormattedNumber
                      value={currentPrice / 100}
                      style="currency"
                    />
                  </Col>
                </Row>
                <div className="summary-line" />
              </div>
            </div>
          </div>

          <div className="d-none d-md-block">
            <CheckoutModalSummary
              itemTotal={itemCount}
              total={currentPrice / 100}
              subtotal={currentFullPrice / 100}
              saving={currentDiscount / 100}
            />
          </div>
        </div>

        <div className="buttons-container">
          <div className="continue-container">
            <Button
              block
              color="secondary"
              onClick={handleModalToggle}
            >
              <FormattedMessage id="bundle-exit-offer-modal.continue-shopping" defaultMessage="Add More to this Bundle" />
            </Button>
          </div>
          <div className="view-container">
            <Link
              to="/cart"
              className="btn btn-block btn-primary"
              onClick={handleModalToggle}
            >
              <FontAwesomeIcon icon={faLock} className="mr-2" />
              <span>
                <FormattedMessage id="bundle-exit-offer-modal.view-cart" defaultMessage="proceed to checkout" />
              </span>
            </Link>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BundleExitOfferModal;
